import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Paper,
  Typography,
  Grid,
  Box,
  IconButton
} from '@mui/material';
import {
  Edit as EditIcon,
  Verified as VerificationIcon,
  LinkOff as UnlinkIcon,
  BarChart,
  BusinessCenter as BusinessCenterIcon
} from '@mui/icons-material';

const BusinessOwnerActions = ({ 
  profileData, 
  ownerView,
  onEditBusiness, 
  onStartVerification, 
  onUnclaim 
}) => {
  const navigate = useNavigate();

    const handleEditBusinessDetails = () => {
    console.log('Navigating to business details edit');
    // The edit form is seeded from router state, so it can only ever send back
    // fields present here. specialFeatures, keywords and additionalInfo moved
    // to the owner endpoint when the public projection became an inclusion
    // list — without merging ownerView they arrive undefined, render blank,
    // and are written as "" on save.
    navigate(`/business/${profileData._id}/edit`, {
      state: { ...profileData, ...(ownerView || {}) },
    });
  };

  const handleStartVerification = () => {
    console.log('Initiating business verification process');
    if (onStartVerification) {
      onStartVerification();
    } else {
      // TODO: Start verification workflow
    }
  };

  const handleUnclaim = () => {
    console.log('Unclaiming business');
    if (onUnclaim) {
      onUnclaim();
    } else {
      // TODO: Implement business unclaim logic
    }
  };

  const handleViewStats = () => {
    navigate(`/business/admin/${profileData._id}`);
  };

  return (
    <Paper variant="outlined" sx={{ p: 0, border: 'none' }}>
      <Typography variant="subtitle2" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <BusinessCenterIcon color="primary" fontSize="small" />
        Business Owner Actions
      </Typography>

      <Grid container spacing={2}>
        {/* Row 1 */}
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton 
              color="primary"
              onClick={handleEditBusinessDetails}
              sx={{ mr: 1 }}
              aria-label="Edit business details"
            >
              <EditIcon />
            </IconButton>
            <Typography variant="body2">Edit Business</Typography>
          </Box>
        </Grid>
        
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton 
              color="secondary"
              onClick={handleViewStats}
              sx={{ mr: 1 }}
              aria-label="View business statistics"
            >
              <BarChart />
            </IconButton>
            <Typography variant="body2">View Stats</Typography>
          </Box>
        </Grid>
        
        {/* Row 2 */}
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton 
              color="info"
              onClick={handleStartVerification}
              sx={{ mr: 1 }}
              aria-label="Start business verification"
            >
              <VerificationIcon />
            </IconButton>
            <Typography variant="body2">Verify</Typography>
          </Box>
        </Grid>
        
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton 
              color="error"
              onClick={handleUnclaim}
              sx={{ mr: 1 }}
              aria-label="Unclaim business"
            >
              <UnlinkIcon />
            </IconButton>
            <Typography variant="body2">Unclaim</Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BusinessOwnerActions;